module.exports = __webpack_public_path__ + "img/ring_r_i_0_1.e9426dd5.png";